import { render, staticRenderFns } from "./ProjectViewTradesGrid.vue?vue&type=template&id=0b21a617&"
import script from "./ProjectViewTradesGrid.vue?vue&type=script&lang=ts&"
export * from "./ProjectViewTradesGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectViewTradesGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports